export const slopeRight = "Slope-bottom-right"
export const slopeLeft = "Slope-bottom-left"
export const slopeDark = "Slope-dark"
